<template>
  <button class="filters__select-boxes-item" :class="[icon ? `has-icon` : '']" v-on:click="handleClick">
    <i v-if="icon" :class="[color ? `color--${color}` : '', icon]" ></i>
    <img v-if="image" class="filters__select-boxes-item__image":src="image.src" :alt="image.alt">
    <span class="filters__select-boxes-item__label">{{label}}</span>
  </button>
</template>

<script type="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import {Image} from "./interfaces";

@Component
export default class BoxesItem extends Vue {
  @Prop({default: null}) id: number | string;
  @Prop({default: null, type: String}) label: string;
  @Prop({default: null, type: String}) icon: string;
  @Prop({default: 'white', type: String}) color: string;
  @Prop({default: null, type: Object}) image?: Image|null;

  public handleClick() {
    this.$emit('select', this.id);
  }
}
</script>